export default __webpack_public_path__ + "static/media/TERRASSE 104 CLICHY (40 sur 53).e2b59497.jpg";